export function dom2text(domStr) {
    const dom = new DOMParser().parseFromString(domStr, 'text/html');
    console.log(dom);
    return dom.querySelector('html').outerText;
}
